import { Toast } from 'vant'
import { queryRegisterCode, querySellGetCode } from '@/api'
export default {
  components: {},
  props: [],
  name: 'resetPassword-page',
  data () {
    return {
      user: {
        name: null,
        organization: null,
        phone: null,
        code: null,
        isChina: true
      },
      timeNum: null,
      timer: null
    }
  },
  computed: {
  },
  watch: {
  },
  created () { },
  mounted () { },
  destroyed () { },
  methods: {
    // 获取验证码
    async inputVerificationCode (type) {
      clearTimeout(this.timer)
      this.timer = setTimeout(async () => {
        if (!type) {
          Toast({ message: '请输入手机号', type: 'fail' })
          return
        }
        this.timeNum = 60
        const { error } = await querySellGetCode({ phone: this.user.phone, isChina: this.user.isChina })
        if (error.returnCode === 0) {
          const set = setInterval(() => {
            this.timeNum = --this.timeNum
          }, 1000)
          setTimeout(() => {
            this.timeNum = null
            clearInterval(set)
          }, 60000)
        } else {
          Toast({ message: error.returnMessage, type: 'error' })
          this.timeNum = null
        }
      }, 500)
    },
    async loginBtnClicked () {
      if (!this.user.name) { Toast({ message: '请输入用户名', type: 'fail' }); return }
      if (!this.user.organization) { Toast({ message: '请输入机构信息', type: 'fail' }); return }
      if (!this.user.phone) {
        Toast({ message: '手机号输入有误', type: 'fail' }); return
      }
      if (!this.user.code) {
        Toast({ message: '验证码输入有误', type: 'fail' }); return
      }
      const { data, error } = await queryRegisterCode(this.user)
      if (data && error.returnCode === 0) {
        this.$router.push({ path: '/adviserHomePage' })
      } else {
        Toast({ message: error.returnMessage, type: 'error' })
      }
    },
    forgetPassword () {
      this.$router.push({ path: '/resetPassword' })
    }
  }
}
